import { Switch } from 'antd';
import React from 'react';
import { disable as darkreaderDisable, enable as darkreaderEnable } from '@umijs/ssr-darkreader';

const updateTheme = async (dark: boolean, color?: string) => {
  if (typeof window === 'undefined') return;
  if (typeof window.MutationObserver === 'undefined') return;

  if (dark) {
    const defaultTheme = {
      brightness: 100,
      contrast: 90,
      sepia: 0,
    };

    const defaultFixes = {
      invert: [],
      css: '',
      ignoreInlineStyle: ['.react-switch-handle'],
      ignoreImageAnalysis: [],
      disableStyleSheetsProxy: true,
    };
    if (window.MutationObserver) darkreaderEnable(defaultTheme, defaultFixes);
  } else {
    if (window.MutationObserver) darkreaderDisable();
  }
};

const DarkModeSwitch: React.FC = () => {
  return (
    <div>
      <Switch
        checkedChildren="Dark mode"
        unCheckedChildren="Light mode"
        onChange={(checked) => updateTheme(checked)}
      />
    </div>
  );
};

export default DarkModeSwitch;
